window.SERVER_DATA = {
  appName: 'FASATReactApplication',
  // apiHost: 'https://10.194.168.250',
  apiHost: '',
  logEndpoint: '/api/log',
  minimumLogLevel: 'verbose',
  consoleLogLevel: 'verbose',
  httpLogLevel: 'verbose',
  i18nResourcePath: '/api/messages/{{lng}}',
  timeout: 600000,
  validateOnBlur: false,
  validateOnChange: false,
  enableDevTool: true,
};
